import gql from "graphql-tag";
import RankedIssuerFields from "lib/fragments/RankedIssuerFields";
import YouTubeVideoFields from "lib/fragments/YouTubeVideoFields";
import TrailingReturnsFields from "lib/graphql/fragments/TrailingReturnsFields";

export default gql`
  fragment BrazilianRealEstateFundTopLevel on BrazilianRealEstateFund {
    _id
    name
    tradingName
    tickerSymbol
    tickerSymbolPrefix
    marketCapitalization {
      totalCapitalization
      asOfDate
    }
    viewerDidBookmark
    cnpj(humanReadable: true)
    startOfOperation(humanReadable: true)
    dateOfDuration
    audience
    shortDescription
    operatingSegment: listingSegment
    b3Href
    fundosNetHref
    website
    isInPortfolio
    isFiagro
    engagementStats {
      totalDiscussionsCommentsCount
      viewerUnseenDiscussionsCommentsCount
    }
    primaryLogo {
      url
      width
      height
    }
    standardLogo {
      url
      geometry
      dominantColor
      colorPalette
    }
    niceLogo {
      url
      geometry
      dominantColor
      colorPalette
    }
    selfRegulation {
      management
      mandate
      primarySegment
    }
    classification
    investmentsProgram
    ifixParticipation {
      asPercentage
    }
    distributionOfAssets {
      cash
      realEstate
      otherInvestments
      fundsOfFunds
      dateOfReference
    }
    administrator {
      name
      cnpj(humanReadable: true)
      compensationPolicy
    }
    manager {
      name
      cnpj(humanReadable: true)
    }
    overview {
      totalOfGrossLeaseableArea
      totalOfRealEstateProperties
      totalOfStates
      totalOfRegions
      totalOfSecurities
      totalOfLands
      totalOfCities
      totalOfTenants
    }
    properties {
      ... on BrazilianRealEstateFundPropertyToRent {
        id
        name
        area
        vacancyRate
        percentOfFundRevenue
        percentOfPropertyRevenue
        address
        location {
          formatted
          city
          state
          abbreviatedStateName
        }
      }
    }
    lastMonthlyReportDate
    lastQuarterlyReportDate
    lastYearlyReportDate
    managementReport {
      type
      category
      dateOfDelivery
      dateOfReference
      linkHref
    }
    ...RankedIssuerFields
    youtubeVideos {
      ...YouTubeVideoFields
    }
    trailingReturns {
      ...TrailingReturnsFields
    }
    liquidityScore {
      calculatedScore
    }
  }

  ${RankedIssuerFields}
  ${YouTubeVideoFields}
  ${TrailingReturnsFields}
`;
